import React from "react";
import PolicyLayout, { PolicyH2, PolicyP, PolicyUL, PolicyCallout } from "../components/app/PolicyLayout";

const TOC = [
  { id: "commitment", label: "1. Our commitment" },
  { id: "standard", label: "2. The standard we aim for" },
  { id: "what", label: "3. What works well" },
  { id: "gaps", label: "4. Known gaps" },
  { id: "feedback", label: "5. Tell us" },
];

export default function Accessibility() {
  return (
    <PolicyLayout
      title="Accessibility Statement"
      eyebrow="WCAG 2.2 AA · UK Public Sector Bodies Accessibility Regulations spirit"
      lastUpdated="23 April 2026"
      toc={TOC}
      testid="accessibility-page"
    >
      <PolicyCallout>
        CampCompass is built so that campers of every kind can use it — whether you're using a screen reader, a
        keyboard, a braille display, or just your phone in bright sunlight.
      </PolicyCallout>

      <PolicyH2 id="commitment">1. Our commitment</PolicyH2>
      <PolicyP>
        We're committed to WCAG 2.2 Level AA as our accessibility baseline. Where we fall short, we'll tell you here
        honestly — and fix it.
      </PolicyP>

      <PolicyH2 id="standard">2. The standard we aim for</PolicyH2>
      <PolicyUL>
        <li>All interactive elements are keyboard-navigable.</li>
        <li>Colour contrast ratios meet WCAG AA (4.5:1 for body, 3:1 for large text).</li>
        <li>Screen-reader-friendly markup (semantic HTML, ARIA where needed).</li>
        <li>All images have descriptive alt text.</li>
        <li>Every form has visible labels and error messages.</li>
        <li>The app works with 200% browser zoom without horizontal scrolling.</li>
        <li>We avoid flashing content (no content flashes more than 3 times per second).</li>
      </PolicyUL>

      <PolicyH2 id="what">3. What works well today</PolicyH2>
      <PolicyUL>
        <li>High-contrast orange/black brand colours pass AA for body and large text.</li>
        <li>Entire app is usable with keyboard only — every button, link, input reachable via Tab.</li>
        <li>Reduced-motion preferences respected (no forced animations).</li>
        <li>Cookie banner and modals trap focus correctly.</li>
      </PolicyUL>

      <PolicyH2 id="gaps">4. Known gaps we're working on</PolicyH2>
      <PolicyUL>
        <li>The interactive Leaflet map has limited screen-reader support — we provide a list view as an alternative.</li>
        <li>Some older community threads have user-uploaded images without alt text — we're rolling out a prompt for authors.</li>
        <li>Full dark-mode is on the roadmap.</li>
      </PolicyUL>

      <PolicyH2 id="feedback">5. Tell us where we fall short</PolicyH2>
      <PolicyP>
        If you hit an accessibility problem — even a small one — email{" "}
        <a href="mailto:accessibility@camp-compass.uk" className="link-underline text-[#ff4500]">accessibility@camp-compass.uk</a>.
        We aim to acknowledge within 2 working days and fix within 30.
      </PolicyP>
    </PolicyLayout>
  );
}
